class CustomTabs extends HTMLElement {
  constructor() {
    super();

    this.tabHeaders = Array.from(this.querySelectorAll('.custom-tab__header'));
    this.tabContents = Array.from(this.querySelectorAll('.custom-tab__content'));

    this.tabHeaders.forEach((header, index) => {
      header.addEventListener('click', () => this.setActive(index));
    });
  }

  setActive(activeIndex) {
    this.tabHeaders.forEach((header, index) => {
      header.classList.toggle('active', index === activeIndex);
    });

    this.tabContents.forEach((content, index) => {
      content.classList.toggle('active', index === activeIndex);
    });
  }
}

if (!customElements.get('custom-tabs')) {
  customElements.define('custom-tabs', CustomTabs);
}
